import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import classnames from "classnames";
import styles from "./PageBaseLayout.module.scss";
export const PageBaseLayout = ({ header, content, aside, exception, ...restProps }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (_jsxs("div", { className: styles.main, "data-testid": "page-base-layout-wrapper", ...restProps, children: [exception, _jsxs("div", { className: classnames(styles.pageLayoutContainer, {
                    [styles.orderExceptionVisible]: !!exception,
                }), children: [header, _jsxs("div", { className: classnames(styles.container, {
                            [styles.orderExceptionVisible]: !!exception,
                            [styles.withAside]: !!aside,
                        }), children: [_jsx("div", { "data-testid": "page-base-layout-content", children: content }), aside && _jsx("div", { "data-testid": "page-base-layout-aside", children: aside })] })] })] }));
};
//# sourceMappingURL=PageBaseLayout.js.map